const faq = {
  title: "Frequently Asked Questions",
  description:
    "Here you will find answers to the 10 questions we are most frequently asked. If you still have questions, contact us. We are happy to help!",
  questions: [
    {
      question: "How easy is it to set up?",
      answer:
        "With one person, you can have the printer assembled and print-ready in 5 minutes. Check it out for yourself!",
    },
    {
      question: "How big of an image can it print?",
      answer:
        "The printer can print images up to 13 feet tall with the extension system, and there are no width limitations.",
    },
    {
      question: "How much does ink cost?",
      answer:
        "Ink costs approximately $0.50 to $2.00 per square meter, depending on the type of ink and surface.",
    },
    {
      question: "How much can you charge for printing jobs?",
      answer:
        "You can charge $20 to $50 per square meter for most projects, depending on the complexity and the market.",
    },
    {
      question: "What kind of market is there for printing?",
      answer:
        "The market includes businesses, homes, event spaces, schools, and more. If there’s a wall, there’s a market for printing on it!",
    },
    {
      question: "How do I remove a print?",
      answer:
        "Prints can be removed by painting over them or using fine-grit sanding, depending on the surface.",
    },
    {
      question: "How do I order ink?",
      answer:
        "You can order ink directly from us or our certified suppliers. We ensure the highest quality for your projects.",
    },
    {
      question: "What can it print on?",
      answer:
        "It can print on nearly any vertical surface, including drywall, wood, metal, glass, brick, and more.",
    },
    {
      question: "What kind of maintenance and service is involved?",
      answer:
        "The printer requires minimal maintenance. Regular cleaning and occasional part replacements will keep it in top shape.",
    },
    {
      question: "Are the prints durable?",
      answer:
        "Yes, prints are scratch-resistant, water-resistant, and UV-stable, ensuring durability for years to come.",
    },
  ],
};

export default faq;
